var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('LayoutHeader'),_c('main',{attrs:{"id":"main"}},[_c('LayoutAside'),_c('div',{attrs:{"id":"pages"}},[_c('router-view')],1),_c('LayoutTrends')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }